export default __webpack_public_path__ + "static/BioRhyme-Light-kern-latin-33cc146eed92c7433eef1e13cdf262ae.woff2";